<template>
  <section id="Webhooks" class="section-item">
    <h1>Webhooks</h1>

    <section id="api-Webhooks-PostSuaurl1">
      <h2>Webhooks - {{$t('title.blacklist_optout')}}</h2>
      <p>
        {{$t('webhooks.blacklist_optout_config_method')}}
      </p>
      <div class="">
        <div class="post type">POST</div>
        <div class="code-toggle">
          <button
            @click="selectedTab = 'json'"
            :class="{ active: selectedTab === 'json' }"
          >
            JSON (Blacklists)
          </button>
          <button
            @click="selectedTab = 'json2'"
            :class="{ active: selectedTab === 'json2' }"
          >
            JSON (Optouts)
          </button>
        </div>
        <pre v-if="selectedTab === 'json'">
          <code class="language-json">{
  "blacklists": [
    {
      "ref": "551100001111",
      "ref_id": "f4c4a9bd-f30d-4927-ad43-ef4cea62e2e3",
      "type": "blacklist",
      "status": "created",
      "channel": "sms",
      "date": "2020-11-07 20:25:00",
      "expired_at": null
    }
  ]
}</code></pre>

        <pre v-if="selectedTab === 'json2'">
          <code class="language-json">{
  "optouts": [
    {
      "ref": "551100001111",
      "ref_id": "f4c4a9bd-f30d-4927-ad43-ef4cea62e2e3",
      "type": "optout",
      "status": "created",
      "channel": "sms",
      "date": "2020-11-07 20:25:00",
      "expired_at": null
    }
  ]
}</code></pre>
      </div>

      <h3>{{$t('general.parameter')}}</h3>
      <table>
        <thead>
          <tr>
            <th>{{$t('general.field')}}</th>
            <th>{{$t('general.type')}}</th>
            <th>{{$t('general.description')}}</th>
            s
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{$t('table.message_id')}}</td>
          </tr>
        </tbody>
      </table>
    </section>

    <section id="api-Webhooks-PostSuaurl">
      <h2>Webhooks - {{$t('title.send_callback')}}</h2>
      <p>
       {{$t('webhooks.callback_url_config_method')}}
      </p>
      <div class="post type">POST</div>
      <div class="code-toggle">
        <button @click="selectedTab = 'json'" :class="{ active: selectedTab === 'json' }">
          RCS
        </button>
        <button
          @click="selectedTab = 'sms'"
          :class="{ active: selectedTab === 'sms' }"
        >
          SMS
        </button>
      </div>
      <pre v-if="selectedTab === 'json'">
          <code class="language-json">
##### Event
{
  "id": "a038b6e6-9fd6-4910-bad7-335c6439c595",
  "timestamp": "2025-10-28T09:28:04-03:00",
  "type": "event",
  "event": {
    "message_id": "a038b689-e799-48e2-85b8-f6ddbf76d5ae",
    "name": "read",
    "data": "+5513997423162",
    "created_at": "2025-10-28T12:27:51.000000Z",
    "error_code": null,
    "error_message": null,
    "ext_id": "12345678"
  }
}

#### Inbound Message 
{
  "id": "a038b726-2e27-474f-b79a-2325ee3cb737",
  "timestamp": "2025-10-28T09:29:10-03:00",
  "type": "message",
  "message": {
    "direction": "inbound",
    "from": "5513997423162",
    "to": "Yup Chat",
    "type": "text",
    "body": {
      "text": "Blz?"
    },
    "sent_at": "2025-10-28T12:28:33.000000Z",
    "agent_id": "52867698-ac7b-4186-a7e9-8525161c8b7f",
    "ext_id": "12345678",
    "id": "a038b726-2d3d-48c3-b1d6-8de3de06909d"
  }
}

</code>
        </pre>

      <pre v-if="selectedTab === 'sms'">
          <code class="language-json">
#### MO (Inbound message)  
{
   "id":"1513cf05-33c8-4b5c-b04c-3ca4acb9b6d2",
   "body":"PARE",
   "type":"MO",
   "from":"5518997797033",
   "to":"1755097338811",
   "status":"received",
   "ext_id":null,
   "url":"79f0f759-eaef-4675-a1ea-28e4d5d75dbc",
   "available_at":"2025-10-28 10:32:18",
   "created_at":"2025-08-13 12:02:18",
   "message_id":"a8296760-54df-0c2b-5dcc-ed8c818f01ec",
   "attempts":0,
   "error_message":null,
   "error_code":null,
   "partner":null,
   "tags":null
}

### DLR
[
   {
      "id":"89a4a759-1108-4da5-972a-13680e3fe34c",
      "from":"29384",
      "to":"5599999999",
      "body":"Envio de mensagem com webhook",
      "status":"sent",
      "error_code":null,
      "error_message":null,
      "ext_id":null,
      "date":"2025-10-28 10:02:15",
      "callback_id":"744942c4-f7fd-4306-aae9-1b6851a0f4ee",
      "attempts":0,
      "url":"https://webhook.site/744942c4-f7fd-4306-aae9-1b6851a0f4e4",
      "tags":null
   }
]

</code>
        </pre>

      <h3>{{$t('general.header')}}</h3>
      <table>
        <thead>
          <tr>
            <th>{{$t('general.field')}}</th>
            <th>{{$t('general.type')}}</th>
            <th>{{$t('general.description')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Content-Type</td>
            <td>String</td>
            <td>{{$t('general.default_value')}} <span class="app-json"  >application/json</span> </td>
          </tr>
        </tbody>
      </table>

      <h3>{{$t('general.parameter')}}</h3>
      <table>
        <thead>
          <tr>
            <th>{{$t('general.field')}}</th>
            <th>{{$t('general.type')}}</th>
            <th>{{$t('general.description')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>dlrs</td>
            <td>String</td>
            <td>{{$t('table.status_callback')}}</td>
          </tr>
          <tr>
            <td>mos</td>
            <td>String</td>
            <td>{{$t('table.response_callback')}}</td>
          </tr>
        </tbody>
      </table>

      <h3>Success 200</h3>
      <table>
        <thead>
          <tr>
            <th>{{$t('general.field')}}</th>
            <th>{{$t('general.type')}}</th>
            <th>{{$t('general.description')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>id</td>
            <td>String</td>
            <td>{{$t('table.callback_id')}}</td>
          </tr>
          <tr>
            <td>from</td>
            <td>String</td>
            <td>
              {{$t('table.sender_la')}}
            </td>
          </tr>
          <tr>
            <td>to</td>
            <td>String</td>
            <td>
              {{$t('table.recipient_la')}}
            </td>
          </tr>
          <tr>
            <td>body</td>
            <td>String</td>
            <td>{{$t('table.message_content')}}</td>
          </tr>
          <tr>
            <td>status</td>
            <td>String</td>
            <td>{{$t('table.message_status')}}</td>
          </tr>
          <tr>
            <td>date</td>
            <td>String</td>
            <td>{{$t('table.date_sent_received')}}</td>
          </tr>
        </tbody>
      </table>
    </section>
  </section>
</template>

<script>
import hljs from "highlight.js";
import "highlight.js/styles/an-old-hope.css";

export default {
  name: "WebhooksComponent",
  data() {
    return {
      selectedTab: "json",
    };
  },
  mounted() {
    this.highlightCode();
  },
  watch: {
    selectedTab() {
      this.$nextTick(() => {
        this.highlightCode();
      });
    },
  },
  methods: {
    highlightCode() {
      document.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightBlock(block);
      });
    },
  },
};
</script>

<style scoped>
.sms-section {
  margin-top: 30px;
  text-align: start;
}

.sms-method {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1rem;
}

pre[class*="language-"] {
  background-color: #000 !important;
  color: var(--green-code);
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
  overflow-x: auto;
  white-space: pre-wrap;
  font-family: var(--font-code);
  margin-bottom: 20px;
}
</style>
